// extracted by mini-css-extract-plugin
module.exports = {"btns":"OrderLevel_btns__2Tg3Q","editBtn":"OrderLevel_editBtn__2ef4Z","deleteBtn":"OrderLevel_deleteBtn__33317"};